module.exports = "<div>\n  <h1>{{ $ctrl.name }}</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/plan/plan.html
// module id = 592
// module chunks = 0